import QRCodeGenerator from './QRCodeGenerator';

export default QRCodeGenerator;
